import React, { useEffect, useState } from 'react';
import moment from 'moment';

import FormContainer from '../../../components/FormContainer';
import Accordion from '../../../components/Accordion';
import Divider from '../../../components/Divider';
import Alert from '../../../components/Alert';
import PageLoader from '../../../components/PageLoader';

import schema from './schema';

import { getEnderecoCobranca, getEnderecoCorrespondencia } from '../../../services';

import { useGlobal } from '../../../contexts/Global/context';

import { PageContainer } from '../../../styles/styles';

import * as S from '../styles';
import AddressCard from '../../../components/Cards/AddressCard';
import { cloneObject } from '../../../utils/cloneObject';

function InfoEmpresa() {
    const { dataActiveContract } = useGlobal();
    const { informacoesEmpresa } = dataActiveContract;

    const [dataForm, setDataForm] = useState(cloneObject(schema));
    const [pageLoading, setPageLoading] = useState(false);

    const [dataBilling, setDataBilling] = useState({});
    const [dataMailing, setDataMailing] = useState({});

    const dataSituations = {
        A: 'Ativa',
        E: 'Encerrada',
        S: 'Suspensa',
        I: 'Inadimplente',
    };

    function getSituacao(situacao) {
        return dataSituations[situacao] || situacao;
    }

    async function loadDataEmpresa() {
        setPageLoading(true);

        const responseMailing = await getEnderecoCorrespondencia(dataActiveContract.numero);

        const responseBilling = await getEnderecoCobranca(dataActiveContract.numero);

        setDataBilling(responseBilling);

        setDataMailing(responseMailing);

        setPageLoading(false);
    }

    useEffect(() => {
        const formattedLimitDate = moment(informacoesEmpresa.dataLimiteEnvio, 'MM/DD/YYYY').format('DD/MM/YYYY');

        const initialValues = {
            numeroDoContrato: { ...dataForm.numeroDoContrato, value: informacoesEmpresa.numContrato },
            cnpj: { ...dataForm.cnpj, value: informacoesEmpresa.cpnj },
            razaoSocial: { ...dataForm.razaoSocial, value: informacoesEmpresa.razaoSocial },
            situacao: { ...dataForm.situacao, value: getSituacao(informacoesEmpresa.situacao) },
            diaVencimentoFatura: { ...dataForm.diaVencimentoFatura, value: informacoesEmpresa.diaVencimentoFatura },
            dataLimiteEnvio: { ...dataForm.dataLimiteEnvio, value: formattedLimitDate },
        };

        setDataForm({
            ...dataForm,
            ...initialValues,
        });

        loadDataEmpresa();
    }, []);

    return (
        <PageContainer>
            <Accordion title="Dados básicos" hasCollapse={false}>
                <FormContainer>
                    <S.CustomInput field={dataForm.razaoSocial} />
                    <S.CustomInput field={dataForm.numeroDoContrato} />
                    <S.CustomInput field={dataForm.cnpj} />
                    <S.CustomInput field={dataForm.situacao} />
                </FormContainer>

                <Divider />

                <FormContainer>
                    <S.CustomInput field={dataForm.diaVencimentoFatura} />
                    <S.CustomInput field={dataForm.dataLimiteEnvio} />
                </FormContainer>
            </Accordion>
            <Accordion title="Dados de endereço" hasCollapse={false}>
                <Alert
                    style={{ display: 'none' }}
                    type={4}
                    title="Você pode editar somente o endereço de correspondência da empresa. Caso seja o mesmo endereço de cobrança ou localização, não será possível editá-lo via portal."
                />
                <FormContainer>
                    <AddressCard title="Endereço" addressType="Localização / Cobrança" endereco={dataBilling} />
                    <AddressCard title="Endereço" addressType="Correspondência" endereco={dataMailing} />
                    <S.SpacingCard />
                </FormContainer>
            </Accordion>
            <PageLoader loading={pageLoading} />
        </PageContainer>
    );
}

export default InfoEmpresa;
